import React, { useEffect, useState } from 'react';
import VerificationPopup from '../modals/VerificationPopup';
import styles from '../../styles/newFeature.module.css';
import content from '../../language/ENGLISH.json'
import { HeroSection, MarqueeComponentHomePage, StackContainers, StackSkeleton } from '../qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import FAQ_mobile from '../Industry/FAQ_mobile';
import FrequentQuestions from '../homePage/FrequentQuestions';
import MobilePDBanner from '../common/MobilePDBanner';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import TestimonialSection from '../common/TestimonialSection';
import MobileTestimonialSection from '../common/MobileTestimonialSection';
import ThreeStepForm from '../common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from '../common/OutletFeatures';
import { useRouter } from 'next/router';

const FruitsVegetableStore = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const [heroReadMore, setHeroReadMore] = useState(false);
    const router = useRouter();

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            image: "/assets/outlet/fruitsVegies/billing.webp",
            tag: "Point of Sale",
            icon: "/assets/groceries/kirana/POS.svg",
            title: "POS Billing Software",
            desc: "QueueBuster billing software is designed in such a fashion that every transaction is dealt with accuracy. Our software takes total care, from bulk orders to individual sales billing, fast and quick with minimum errors and maximum customer satisfaction. Integrated multiple payment methods for smooth checkout for your customer.",
            tagColor: "#8AE4F6",
            bgColor: "#8ae4f626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "10rem",
            meHeight: "28rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Bulk and Individual sales processing with accuracy.
                </>,
                <>
                    Eliminate billing mistakes and thereby increase customer satisfaction.
                </>,
                <>
                    Enjoy convenient and easy transactions with various modes of paying bills.
                </>,
            ],
        },
        {
            id: 2,
            image: "/assets/outlet/fruitsVegies/business-management.webp",
            tag: "Inventory Management",
            icon: "/assets/outlet/iceCreamOutlet/inventoryManagementIcon.svg",
            title: "Business Management Software",
            desc: "Our Management Software is the single point from where you can run your entire business. It will help you keep track of your inventory, sales, and supplier lists. In contact with real-time data and overall reporting, you will be in an informed position to make decisions for the smooth running of your business.",
            tagColor: "#FFBA00",
            bgColor: "#fff7e2",
            stackColor1: "#FEF8EB",
            stackColor2: "#FEEAC0",
            stackColor3: "#FFD579",
            stackColor4: "#FFC23E",
            sHeight: "10rem",
            eHeight: "26rem",
            msHeight: "15rem",
            meHeight: "41rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Monitor inventory and track sales from one single platform.
                </>,
                <>
                    Manage suppliers efficiently with real-time data.
                </>,
                <>
                    Report and analytics in great detail to base your business decisions on.
                </>,
            ],
        },
        {
            id: 3,
            image: "/assets/outlet/fruitsVegies/barcode.webp",
            tag: "Barcode Scanning",
            icon: "/assets/outlet/iceCreamOutlet/barcode.svg",
            title: "Fast Checkouts, Flawless Inventory",
            desc: "The QueueBuster POS system has advanced barcode scanning integrated for purposes of speeding up the checkout process. Whether it's an influx of customers or otherwise different volumes of inventory, barcode scanning does guarantee that it's all accounted for accurately and efficiently.",
            tagColor: "#EEC9FF",
            bgColor: "#fcf6ff",
            stackColor1: "#FCF7FF",
            stackColor2: "#F4E1FF",
            stackColor3: "#EEC9FF",
            stackColor4: "#E4ADFE",
            sHeight: "10rem",
            eHeight: "29rem",
            msHeight: "17rem",
            meHeight: "45rem",
            btnText: "Talk	to an expert",
            points: [
                <>
                    Advance your checkouts by using barcode scanning.
                </>,
                <>
                    Handle a high volume of customers seamlessly without compromising on accuracy.
                </>,
                <>
                    Stock up on everything under your inventory list.
                </>,
            ],
        },
        {
            id: 4,
            image: "/assets/outlet/fruitsVegies/weighing.webp",
            tag: "Weighing Scale Integration",
            icon: "/assets/outlet/iceCreamOutlet/integration_pos.svg",
            title: "Ensure Accurate Charges by Weight",
            desc: "QueueBuster's POS system is integrated with weighing scales for the correct weight on every purchase. Ideal for fresh produce, our solution ensures that you can charge the customers correctly according to weight and avoid other glitches to keep customers' trust restored.",
            tagColor: "#4EEAC2",
            bgColor: "#e6fff9",
            stackColor1: "#C8F4E9",
            stackColor2: "#9EE9D6",
            stackColor3: "#4EEAC2",
            stackColor4: "#47DDB6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Accurate measurement is guaranteed on each transaction.
                </>,
                <>
                    Charge the consumer accordingly as per the weight.
                </>,
                <>
                    Gain consumer trust by avoiding discrepancies.
                </>,
            ],
        },
        {
            id: 5,
            image: "/assets/outlet/fruitsVegies/smarter-procurement.webp",
            tag: "Procurement Management",
            icon: "/assets/outlet/iceCreamOutlet/productmanage.svg",
            title: "Prevent Shortages, Eliminate Overstock",
            desc: "QueueBuster enables you to taper your procurement very smoothly to avoid overstocking of unwanted items and running out of fast-moving items. Our system enables you to buy correctly by highlighting the inventories and sale trends so that there is always optimum stock on hand.",
            tagColor: "#FFC3C3",
            bgColor: "#FFF3F3",
            stackColor1: "#FFF3F3",
            stackColor2: "#FFEBEB",
            stackColor3: "#FFDBDB",
            stackColor4: "#FFC3C3",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Streamline procurement to avoid overstocking or shortage.
                </>,
                <>
                    Utilize your understanding of inventory levels and sales trends to make wiser purchases.
                </>,
                <>
                    Always have just enough stock on hand.
                </>,
            ],
        },
    ];

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is so special about QueueBuster Fruits & Vegetable POS as compared to any other POS system?
                </span>
            ),
            des: "The QueueBuster Fruits & Vegetable POS is specifically designed for unique fruit and vegetable business demands, integrating features like weighing scale integration, barcode scanning, and advanced inventory management. In fact, with these qualities, it is possible to maintain accuracy and efficiency in any transaction. Unlike any other common kind of POS system, QueueBuster offers advanced tools at the POS to make operations smooth, less erroneous, and customer satisfaction high. With this, it will suit both small grocery stores and large supermarkets.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the billing software handle bulk and individual sales?
                </span>
            ),
            des: "QueueBuster's Billing Software has been designed to be accurate for bulk and individual sales. It can process large orders in the least amount of time without sacrificing accuracy, recording each transaction correctly. The system also supports multiple modes of payment towards a smooth checkout for customers who purchase either in bulk or individually.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can QueueBuster help me manage my Inventory effectively?
                </span>
            ),
            des: "Definitely! QueueBuster Management Software is one of those hubbed platforms you have been looking for, for real-time tracking of your whole inventory. The system tracks your stock levels, alerts you when the stock is low, and allows you to review and manage your supplier relationships effectively. In fact, with detailed reporting and analytics, you can come up with effective decisions to optimize your inventory and minimize waste.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does barcode scanning improve the checkout process?
                </span>
            ),
            des: "Scanning barcodes through the QueueBuster POS system does much to quicken the pace of checking out, as it rapidly and accurately records each item. It reduces waiting time for every customer in a queue, reducing human errors in billing. Whether you have a large volume of customers or complex inventory to handle, barcode scanning will ensure that everything is efficiently accounted for.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What are the benefits of weighing scales integrated with the POS system?
                </span>
            ),
            des: "Weighing scale integration is critical for businesses that deal in fresh produce where the weight has to be measured out correctly. QueueBuster's POS system ensures every transaction is based on the right weight as you get to charge customers accurately. In fact, it helps you to win the customers' trust by not having fishermen and women cross with the pricing and keeps the transaction open-ended.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster POS help in avoiding overstocking or stockouts?
                </span>
            ),
            des: "QueueBuster's inventory management comprises real-time tracking and automated alerts that allow you to optimize your stock. The system analyzes sales trends and inventory data for actionable insights about your purchasing decisions to have optimum stock in store. This minimizes the risks of overstocking on slow-moving items and going out of fast-selling products.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How user-friendly is the POS to employees of all technological backgrounds?
                </span>
            ),
            des: "Yes, QueueBuster Fruits & Vegetable POS is highly designed with a user-friendly interface that allows for easy navigation and operation-even by non-tech-savvy personnel. The intuitively developed design of the system greatly reduces the time needed for employee learning, the time they then spend on improving their effectiveness. Effortless execution of features like billing, inventory management, or barcode scanning makes daily tasks easy and hassle-free.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster support multiple modes of payment at the checkout counter?
                </span>
            ),
            des: "QueueBuster's Billing Software fully supports different modes of payment, starting from cash up to credit cards, mobile, and digital wallets. The system is designed in such a way that it integrates seamlessly all modes of payment to ensure that a transaction is processed smoothly and without errors. This flexibility will allow customers to check out in their comfort, without having to take into account what mode of payment they are using.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is the business reporting in QueueBuster POS detailed in nature?
                </span>
            ),
            des: "Yes, QueueBuster's reporting and analytics, in a complete fashion, ensure that you gain deeper insights into your business functioning. You can generate detailed reports that describe the sales, inventory levels, supplier activity, and customer behavior. These reports identify trends, ensure better decisions are made based on data analysis, and bring better optimization in your business operations so that maximum efficiency and profit can be assured.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How Safe is Your Transaction Data on QueueBuster?
                </span>
            ),
            des: "QueueBuster takes seriously its role in securing all data that is part of a transaction. Advanced security features on the system are industrial-standards-compliant. More importantly, sensitive information like payment details is all encrypted and safely stored in the system. All the new software updates and relevant security protocols are performed regularly to protect it from any potential danger, ensuring that you can rest assured that your business and your customers' data are secure.",
            id: 10,
            activeIndex: 0,
        },
    ];

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/outlet/fruitsVegies/mobile-hero-img.webp')" }}>
                        <div>
                            <h1>
                                <span> Billing Software for </span><span></span>
                                <span>&nbsp; Fruits & Vegetable POS</span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>Fruit and vegetable business management requires accuracy in speed and a deep understanding of inventory management. QueueBuster Fruits & Vegetable POS is designed to meet such requirements and thus offers an integrated solution for increasing billing accuracy, making inventory tracking easier, and smoothing business operations. Be it small grocery stores or big supermarkets, our POS is meant to optimize all your processes and keep your fruits and vegetables business running.</p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 5rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/outlet/fruitsVegies/hero-img.webp"
                            heading={<>Billing Software for</>}
                            staticHeading={<>Fruits & Vegetable POS</>}
                            description={"Fruit and vegetable business management requires accuracy in speed and a deep understanding of inventory management. QueueBuster Fruits & Vegetable POS is designed to meet such requirements and thus offers an integrated solution for increasing billing accuracy, making inventory tracking easier, and smoothing business operations. Be it small grocery stores or big supermarkets, our POS is meant to optimize all your processes and keep your fruits and vegetables business running."}
                            solidBtnText={"Contact Sales"}
                            textContainerStyle={{ width: "55%" }}
                            setDemoModal={setDemoModal}
                        />
                    </div>
            }

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.features_section}>
                <div className={styles.section_heading}><h3>Salient Features of QueueBuster Fruits & Vegetable POS</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <OutletFeatures features={features} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
            </div>

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"FAQs for QueueBuster Fruits & Vegetable POS"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"FAQs for QueueBuster Fruits & Vegetable POS"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}

export default FruitsVegetableStore